app.controller("ExamsManagerAddItemController", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "$state", "$uibModal", "toastr", "Students",
    function ($scope, ExamsManagerService, $uibModalInstance, $state, $uibModal, toastr, Students) {

        // $scope.chosenStudent;
        $scope.chosenSubject = null;
        $scope.chosenSession = null;
        $scope.chosenSeat = null;
        $scope.add = function () {
            var seatVal = 0;
            if ($scope.chosenSeat) {
                seatVal = $scope.chosenSeat;
            }
            console.log($scope.chosenSubject);
            ExamsManagerService.addExamItem({
                studentId: $scope.chosenStudent._id,
                subjectId: $scope.chosenSubject.subject._id,
                subjectSelectionId: $scope.chosenSubject._id,
                sessionId: $scope.chosenSession._id,
                seat: seatVal
            }).then(function () {
                toastr.success('', 'გამოცდა რედაქტირებულია');
                $uibModalInstance.close();
            });
        };

        $scope.getSessionsWithFreeSeats = function () {
            return ExamsManagerService.getSessionsWithFreeSeats().then(function (data) {
                $scope.sessions = data;
            });
        };

        $scope.getSessionsWithFreeSeats();

        $scope.studentChanged = function () {
            // if($scope.chosenStudent._id){
            //     console.log($scope.chosenStudent);
            // }
            $scope.chosenSubject = null;
            $scope.getSubjects();
        };

        $scope.getSubjects = function () {
            ExamsManagerService.fetchUnlistedSubjectsByStudent({studentId: $scope.chosenStudent._id})
                .then(function (subjects) {
                    $scope.subjects = subjects;
                });
        };

        $scope.getStudents = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Students.list({query: query, state: "active"}).then(function (data) {
                return data.docs;
            });
        };

        $scope.itemChanged = function () {
            $scope.chosenSeat = null;
            $scope.chosenSession = $scope.sessions.filter(function (e) {
                return e._id === $scope.session;
            })[0];
            // console.log($scope.chosenSession);
            $scope.seats = $scope.chosenSession.seats;
            // console.log($scope.chosenSubject);
        };

        $scope.seatChanged = function () {
            // console.log($scope.chosenSeat);
            // console.log($scope.chosenSession);
            // console.log($scope.chosenSession.examHall.withComputers);
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
